import { Injectable } from "@angular/core";
import { Router, UrlTree } from "@angular/router";
import { RoleService } from "../services/role.service";

@Injectable({ providedIn: 'root' })
export class UserGuard {
    constructor(private roleService: RoleService, private router: Router) { }

    // [AUTH-26] Redirect instead of returning false (which left the user on a blank page):
    // testees go to their testing area, everyone else to login. RoleService never throws
    // (AUTH-25), so navigation cannot break on a malformed token.
    canActivate(): boolean | UrlTree {
        if (this.roleService.isUser()) {
            return true;
        }

        return this.router.createUrlTree(this.roleService.isTestee() ? ['/testing'] : ['/auth/login']);
    }
}
